import { useTranslation } from "react-i18next";

import { Card, CardBody, Col, Container, Row } from "reactstrap";
import { Link } from "react-router-dom";
import NavigationBreadcrumbs from "../../../common-elements/breadcrumbs/NavigationBreadcrumbs";
import CardHeaderCommon from "../../../common-elements/card-header-common/CardHeaderCommon";
import CountryListData from "./CountryListData";

export default function CountryList() {
  const { t } = useTranslation();
  return (
    <>
      <NavigationBreadcrumbs
        mainTitle={t("Holidays")}
        parent={t("Master Data")}
        links={[
          { label: "Holidays", active: true },
        ]}
      />
      <Container fluid>
        <Row>
          <Col sm="12">
            <Card>
              <CardBody>
                <div className="list-product-header">
                  <div className="d-flex justify-content-between align-items-center mb-3 ">
                    <CardHeaderCommon title={t("Countries")} />

                    <div className="d-flex gap-2">
                      <Link
                        className="btn btn-primary"
                        to={`${process.env.PUBLIC_URL}/masterdata/new-holiday`}
                      >
                        <i className="fa fa-plus" />
                        {t("AddHolidays")}
                      </Link>
                      <Link
                        className="btn btn-success"
                        to={`${process.env.PUBLIC_URL}/masterdata/import-holiday`}
                      >
                        <i className="fa fa-download" />
                        {t("Import")}
                      </Link>
                    </div>
                  </div>
                </div>
                <CountryListData />
              </CardBody>
            </Card>
          </Col>
        </Row>
      </Container>
    </>
  );
}
